import env from "../../env";
export const REACT_APP_API_SERVER_URL = `${env.REACT_APP_API_SERVER_URL}`;
export const PAGE_SIZE = 10;
